// extracted by css-extract-rspack-plugin
export default {"btn":"kB0XE7uHz63moOMhfnv9","tonal":"_B2QparVpZHJ_6hDt9xP"};